const { render, useState } = wp.element;
import React, { Component } from 'react';
import { Alert, AlertTitle } from '@mui/material';

class CriticalError extends Component {
    render() {
        return (
            <Alert severity="error">
                <AlertTitle>Error</AlertTitle>
                <div dangerouslySetInnerHTML={{ __html: this.props.msg }} />
            </Alert>
        )
    }
}

export default CriticalError;